import React, {useEffect} from "react";


export default () => {

    useEffect(() => {

        document.title = "1Day1Job";
        const lang = navigator.language || navigator.userLanguage;
        
        if( (String(lang).startsWith('ko')) ){
            document.location.href='/kr'
        }else if( (String(lang).startsWith('ja')) ){
            document.location.href='/jp'
        }else{
            document.location.href='/en'
        }


      }, []);

    return (<></>);


}